import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="character-limit"
export default class extends Controller {
  static values = { maxChars: Number, counterSelector: String }

  connect() {
    this.maxChars = this.maxCharsValue || 140
    
    // Find counter element using selector if provided
    if (this.counterSelectorValue) {
      this.counter = document.querySelector(this.counterSelectorValue)
    }
    
    this.check()
  }

  // Handle input events (covers typing, pasting, etc.)
  input(event) {
    this.check()
  }

  // Handle keyup events for additional responsiveness
  keyup(event) {
    this.check()
    event.stopPropagation()
    event.preventDefault()
  }

  // Handle keypress events
  keypress(event) {
    this.check()
    event.stopPropagation()
  }

  check() {
    const query = this.element.value || ''
    
    if (!query && this.counter) {
      this.counter.textContent = this.maxChars
      this.counter.style.color = 'red'
      this.dispatch('uncross')
      return
    }

    if (this.counter) {
      this.counter.textContent = query.length
    }

    if (query.length > this.maxChars) {
      if (this.counter) this.counter.style.color = 'red'
      this.dispatch('cross')
    } else if (query.length > this.maxChars - 20) {
      if (this.counter) this.counter.style.color = 'orange'
      this.dispatch('uncross')
    } else {
      if (this.counter) this.counter.style.color = 'green'
      this.dispatch('uncross')
    }
  }
}